import React from "react"
import { SvgElectrical01 } from "@digits-shared/components/SVGIcons/line/Electrical01.svg"
import useSession from "@digits-shared/hooks/useSession"
import { AspectCode } from "@digits-shared/session/AspectCode"
import styled from "styled-components"
import { SIDEBAR_PATH_SVG_STYLES } from "src/frontend/components/Shared/NavSidebar/sidebarConstants"
import { SidebarRow } from "src/frontend/components/Shared/NavSidebar/SidebarExpando"
import { RequiresRead } from "src/frontend/components/Shared/Permissions/Requires"
import { RequiresAspect } from "src/frontend/components/Shared/Permissions/RequiresAspect"
import routes from "src/frontend/routes"
import type FrontendSession from "src/frontend/session"
import {
  FrontendPermissionModule,
  FrontendPermissionSource,
} from "src/frontend/session/permissionModule"

const ConnectionsIcon = styled(SvgElectrical01)`
  ${SIDEBAR_PATH_SVG_STYLES};
`

/*
  COMPONENT
*/

export const ConnectionsSidebar: React.FC = () => {
  const { currentLegalEntity } = useSession<FrontendSession>()
  if (!currentLegalEntity?.id) return null

  return (
    <RequiresAspect aspect={AspectCode.Connections}>
      <RequiresRead
        source={FrontendPermissionSource.LegalEntity}
        module={FrontendPermissionModule.Connections}
      >
        <SidebarRow
          Icon={ConnectionsIcon}
          route={routes.connections}
          params={{ leSlug: currentLegalEntity.slug, rie: "1" }}
        >
          Connections
        </SidebarRow>
      </RequiresRead>
    </RequiresAspect>
  )
}
